<template>
  <section class="loa-information" v-if="loa_level != 0">
    <b-card>
      <div class="mt-2 mb-">{{ $t("LOA.CONTACT") }}
        <br />{{ $t('LOA.WRONG_LEVEL1')}} <strong>{{  user.auth_loa }}</strong> {{ $t('LOA.WRONG_LEVEL2')}}  <strong>{{ loa_level }}</strong> {{ $t('LOA.WRONG_LEVEL3')}}.
        </div>
        <div class="mt-2 mb-">
        <strong>{{ $t('LOA.WRONG_LEVEL4')}}</strong>
      </div>
    </b-card>
        <b-card>
          <div class="mt-2 mb-">
            <p class="bodytext">{{ $t("LOA.DESCRIPTION") }}</p>
            <p class="bodytext">{{ $t("LOA.EXAMPLE") }}</p>
          </div>
        </b-card>
  </section>
</template>
<script>
export default {
  props: ["loa_level"],
  data() {
    return {
      loading: false,
      loa3list: [],
      loa2list: [],
      loa1list: [],
    };
  },
  methods: {
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
  },
};
</script>
<style></style>
